const User = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 8 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.58313 6.68254C0.58313 5.47722 1.56023 4.50012 2.76555 4.50012H5.20886C6.41418 4.50012 7.39128 5.47722 7.39128 6.68254C7.39128 7.08431 7.06558 7.41001 6.66381 7.41001H1.3106C0.908831 7.41001 0.58313 7.08431 0.58313 6.68254Z"
        fill="#AEB9E1"
      />
      <path
        d="M3.98851 3.94565C5.05991 3.94565 5.92844 3.07712 5.92844 2.00572C5.92844 0.934331 5.05991 0.0657959 3.98851 0.0657959C2.91712 0.0657959 2.04858 0.934331 2.04858 2.00572C2.04858 3.07712 2.91712 3.94565 3.98851 3.94565Z"
        fill="#AEB9E1"
      />
    </svg>
  );
};

export default User;
